(ns ductile.ui.compound
  (:require [clojure.edn :as edn]
            [clojure.string :as str]
            [ductile.base64u :as base64]
            [ductile.clerk.viewer :as dcv]
            [ductile.time.format :as time-format]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.components.table :as table]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.icons :as icons]
            [ductile.ui.locale :as locale :refer [tr]]
            [ductile.ui.router :as router]
            [ductile.ui.scene :as scene]
            [ductile.ui.schema-based-editor :as schema-based-editor]
            [ductile.ui.vehicle-search :as ui.vehicle-search]
            [ductile.util :refer [ok-> ok->>]]
            [goog.string.format]
            [malli.core :as m]
            [malli.util]
            [nextjournal.clerk.render :as render]
            [nextjournal.clerk.render.hooks :as hooks]
            [nextjournal.clerk.viewer :as viewer]
            [nextjournal.log :as log]
            [reagent.core :as r])
  (:require-macros [ductile.ui.macros :refer [defc]]
                   [ductile.ui.scene.macros :refer [defscene]]))

(def colors
  ["red-500" "yellow-500" "green-500" "blue-500" "indigo-500" "purple-500" "pink-500"
   "red-200" "yellow-200" "green-200" "blue-200" "indigo-200" "purple-200" "pink-200"])

(defn with-colors [cs]
  (map-indexed (fn [i c] (assoc c :color (nth colors i "gray-300"))) cs))

(defn capacity-chart [{:keys [capacities fahrzeuge max-capacity]}]
  (let [total (count fahrzeuge)
        free (- max-capacity total)]
    [:div
     [:div.overflow-hidden.w-full.flex.h-8.rounded.shadow
      {:style {:outline "1px solid rgba(0,0,0,.1)"
               :outline-offset "-1px"}}
      (into
       [:div.flex-auto.flex]
       (->> capacities
            with-colors
            (map (fn [{:keys [color count]}]
                   [:div
                    {:class (str "bg-" color)
                     :style {:width (str (* (/ count total) 100) "%")}}]))))
      [:div.border-l.border-dashed.border-blue-500 {:style {:width (str (* (/ free max-capacity) 100) "%")}}]]]))

(defn capacity-table [{:keys [capacities fahrzeuge]}]
  [:div.overflow-hidden.border-t
   [:table.min-w-full.divide-y.divide-gray-200
    [:thead.bg-gray-50
     [:tr
      [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
       {:scope "col"}
       [:div.rounded-full.w-4.h-4.border.border-gray-300]]
      [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
       {:scope "col"}
       (tr "Contract")]
      [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
       {:scope "col"}
       (tr "Description")]
      [:th.px-5.py-2.text-right.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
       {:scope "col"}
       (tr "Amount")]]]
    (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
          (->> capacities
               with-colors
               (map
                (fn [c]
                  [:tr.hover:bg-gray-50.cursor-pointer
                   [:td.pl-5
                    [:div.rounded-full.w-4.h-4.border {:class (str "bg-" (:color c))}]]
                   [:td.pl-5.py-2.whitespace-nowrap.text-xs (:customer/name c)]
                   [:td.pl-5.py-2.whitespace-nowrap.text-xs.text-xs (:contract/description c)]
                   [:td.px-5.text-right.py-2.px-6.whitespace-nowrap.text-xs (:count c)]]))))
    [:tfoot.bg-white.divide-y.divide-gray-200.text-sm
     [:tr.bg-gray-50
      [:td]
      [:td.pl-5.py-2.whitespace-nowrap.font-bold.text-xs
       {:col-span 2}
       (tr "Total")]
      [:td.text-right.py-2.px-5.whitespace-nowrap.font-bold.text-xs
       (count fahrzeuge)]]]]])

(defn transport-mode-chart [{:keys [fahrzeuge]}]
  (let [total (apply + (map :count fahrzeuge))]
    [:div.px-5.py-2.bg-slate-50
     [:div.overflow-hidden.w-full.flex.h-8.rounded.shadow
      {:style {:outline "1px solid rgba(0,0,0,.1)"
               :outline-offset "-1px"}}
      (into
       [:div.flex-auto.flex]
       (->> fahrzeuge
            with-colors
            (map (fn [{:keys [color count]}]
                   [:div.text-xs.font-bold.text-white.text-center.p-2
                    {:class (str "bg-" color)
                     :style {:width (str (* (/ count total) 100) "%")}}]))))]]))

(defn transport-mode-table [{:keys [fahrzeuge]}]
  [:table.min-w-full.divide-y.divide-gray-200.rounded-lg.p-2.border.border-t-slate-200
   [:thead.bg-slate-50
    [:tr
     [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
      {:scope "col"}]
     [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
      {:scope "col"}
      (tr "Transport mode")]
     [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
      {:scope "col"}
      (tr "# of vehicles")]]]
   (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
         (->> fahrzeuge
              with-colors
              (map
               (fn [f]
                 [:tr.hover:bg-gray-50.cursor-pointer
                  [:td.pl-5
                   [:div.rounded-full.w-4.h-4.border {:class (str "bg-" (:color f))}]]
                  [:td.pl-5.py-2.whitespace-nowrap.text-xs (name (:transport/mode f))]
                  [:td.pl-5.py-2.whitespace-nowrap.text-xs.text-xs (:count f)]]))))
   [:tfoot.bg-white.divide-y.divide-gray-200.text-sm
    [:tr.bg-gray-50
     [:td.pl-5.py-2.whitespace-nowrap.font-bold.text-xs
      (tr "Total")]
     [:td]
     [:td.text-left.py-2.px-5.whitespace-nowrap.font-bold.text-xs
      (reduce + (map :count fahrzeuge))]]]])

(defn vehicles-by-transport-mode [fahrzeuge]
  (let [grouped-by-mode (group-by #(-> % :entry/transport-order :transport/mode) fahrzeuge)]
    (map (fn [[mode fahrzeuge]]
           {:count (count fahrzeuge)
            :transport/mode (or mode :mode/unknown)}) grouped-by-mode)))

(defn location-name [e]
  (or (:compound/name e)
      (:location/name e)
      (when (:external.bmw/location-codes e)
        (str/join ", " (:external.bmw/location-codes e)))))


(defn vehicles-by-origin [fahrzeuge]
  (let [grouped-by-origin (group-by (fn [f] (let [origin-location (-> f :entry/transport-order :origin/location)]
                                              (location-name origin-location))) fahrzeuge)]
    (map (fn [[origin fahrzeuge]]
           {:origin/location (or origin "Unknown location")
            :count (count fahrzeuge)}) grouped-by-origin)))

(defn vehicles-by-destination [fahrzeuge]
  (let [grouped-by-destination (group-by (fn [f] (let [destination-location (-> f :exit/transport-order :destination/location)]
                                                   (location-name destination-location))) fahrzeuge)]
    (map (fn [[destination fahrzeuge]]
           {:destination/location (or destination "Unknown location")
            :count (count fahrzeuge)}) grouped-by-destination)))

(defn vehicles-by-date [fahrzeuge]
  (let [grouped-by-date (group-by :entry/expected-datetime fahrzeuge)]
    (into {}
          (map (fn [[date fahrzeuge]]
                 {(if date
                    (time-format/->str {:format :date} date)
                    "Unknown") (count fahrzeuge)}) grouped-by-date))))

(defn transport-orders-overview [{:as state :keys [fahrzeuge]}]
  (let [grouped-by-origin (sort-by (comp - :count) (vehicles-by-origin fahrzeuge))
        grouped-by-mode (sort-by (comp - :count) (vehicles-by-transport-mode fahrzeuge))
        grouped-by-date (sort-by (comp - :count) (vehicles-by-date fahrzeuge))
        exiting-fahrzeuge (filter #(:exit/transport-order %) fahrzeuge)
        grouped-by-destination (sort-by (comp - :count) (vehicles-by-destination exiting-fahrzeuge))]
    [:div.bg-slate-200.min-h-screen
     [ui/nav-bar]
     [:div.p-5
      [:h3.text-2xl.my-4 "Active transport orders"]
      [:div.rounded-md.bg-slate-50.border.border-slate-200.flex.flex-col.text-lg.w-full.mb-5.shadow-md.overflow-hidden.mr-4
       [:div.bg-slate-100.p-4.border-b.border-b-slate-200
        [:h2.text-lg.font-bold [:span "Entry"]]]

       [:div.grid.grid-cols-2.p-4
        [:div.border.border-slate-200.rounded-lg.shadow-md.overflow-hidden.h-fit.m-2
         [:div.border-b.border-slate-200.bg-slate-100.py-2.px-5 [:h2.text-base.font-bold "Transport modes"]]
         [transport-mode-chart {:fahrzeuge grouped-by-mode}]
         [transport-mode-table {:fahrzeuge grouped-by-mode}]]
        [:div.border.border-gray-200.rounded-md.bg-slate-50.m-2.shadow-md
         [:div.border-b.border-slate-200.bg-slate-100.px-5.py-2
          [:h2.text-base.font-bold "Origin locations"]]
         (into [:div.flex.flex-col.p-4]
               (map (fn [{:keys [origin/location count]}]
                      [:span [:span.text-lg.font-bold.text-indigo-700 count]
                       [:span.text-sm.text-gray-700 " from "] [:span.text-sm.font-bold.text-gray-700 location]]) grouped-by-origin))]
        [:div.overflow-hidden.border.rounded-md.border-slate-200.m-2.shadow-md.bg-slate-50
         [:table.min-w-full
          [:thead.bg-slate-100
           [:tr.border-b
            [:th.px-5.py-2.text-sm.text-left.text-lg.font-bold {:col-span 2}
             [:h2.text-base.font-bold "Expected entry date"]]]
           [:tr.border-b
            [:th.px-5.py-2.text-left.text-xs.uppercase.tracking-wider "# of vehicles"]
            [:th.px-5.py-2.text-left.text-xs.uppercase.tracking-wide "Date"]]]
          (into [:tbody]
                (map (fn [[date count]]
                       [:tr.text-xs
                        [:td.px-5.py-2.text-left count]
                        [:td.px-5.py-2.text-left date]]) (sort-by val grouped-by-date)))]]]]

      [:div.rounded-md.bg-slate-50.border.border-slate-200.flex.flex-col.text-lg.w-full.my-5.shadow-md.overflow-hidden.mr-4
       [:div.bg-slate-100.p-4.border-b.border-b-slate-200
        [:h2.text-lg.font-bold [:span "Exit"]]]
       [:div.grid.grid-cols-2.p-4
        [:div.border.border-slate-200.rounded-lg.shadow-md.overflow-hidden.h-fit.m-2
         [:div.border-b.border-slate-200.bg-slate-100.px-5.py-2
          [:h2.text-base.font-bold "Transport modes"]]
         [transport-mode-chart {:fahrzeuge (vehicles-by-transport-mode exiting-fahrzeuge)}]
         [transport-mode-table {:fahrzeuge (vehicles-by-transport-mode exiting-fahrzeuge)}]]
        [:div.border.bg-slate-50.rounded-md.overflow-hidden.m-2.shadow-md
         [:div.border-b.border-slate-200.bg-slate-100.px-5.py-2
          [:h2.text-base.font-bold "Destination locations"]]
         (conj
          (into [:div.flex.flex-col.p-4]
                (map (fn [{:keys [destination/location count]}]
                       [:span
                        [:span.text-lg.font-bold.text-indigo-700 count]
                        [:span.text-sm.text-gray-700 " to "]
                        [:span.text-sm.font-bold.text-gray-700 location]])
                     (take 10 grouped-by-destination)))
          (when (seq (drop 10 grouped-by-destination))
            [:span
             [:span.text-lg.font-bold.text-indigo-700 (reduce + (map :count grouped-by-destination))]
             [:span.text-sm.text-gray-700 " to "]
             [:span.text-sm.font-bold.text-gray-700 "Other locations"]]))
         #_[:table.min-w-full.bg-slate-50
            [:thead
             [:tr.border-b.
              [:th.px-3.py-2.text-sm.font-bold.text-left.bg-slate-100 {:col-span 2} [:h3.text-lg "Destination locations"]]]
             [:tr.border-b
              [:th.px-3.py-2.text-left.text-xs.uppercase.tracking-wider "# of vehicles"]
              [:th.px-3.py-2.text-left.text-xs.uppercase.tracking-wide "To"]]]
            (conj
             [:tr.text-xs
              [:td.px-3.py-2.text-left (reduce + (vals (drop 10 (sort-by val > (vehicles-by-destination exiting-fahrzeuge)))))]
              [:td.px-3.py-2.text-left "Other"]])
            #_[:tfoot
               [:tr
                [:td.px-3.py-2.text-left
                 [:a.text-xs.w-full.text-indigo-700.flex.items-center.justify-start.cursor-pointer.hover:underline "View all"
                  [ui/icon {:size 12} :arrow-right]]]]]]]]]]]))

(defscene show-transport-orders
  [transport-orders-overview
   {:fahrzeuge
    [{:ductile/location {:db/id [:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40"]},
      :fahrzeug/storage-care-start-datetime #inst"2023-03-24T00:00:00.000-00:00",
      :entry/transport-order {:ductile/id #uuid"a6b474a5-367e-48be-a218-2a173bd8dc65",
                              :origin/location {:ductile/id #uuid"c265c10c-2143-4155-9c29-55708e7cffe2",
                                                :location/name "Dingolfing",
                                                :external.bmw/location-codes #{"DGFPL"}},
                              :destination/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                                     :compound/name "Ravenna",
                                                     :compound/company {:db/id [:ductile/id
                                                                                #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                                     :external.bmw/location-codes #{"RAVPOD"}},
                              :transport/mode :mode/train,
                              :transport/load-number "734184123802911414-3",
                              :external.bmw/carrier-code "0068207710",
                              :external.bmw/spediteur "0000021",
                              :edi/instruction-ids #{"148314" "148315"}},
      :fahrzeug/customer {:db/id [:ductile/id #uuid"60f055be-177e-4603-b9a7-3b0f7bb2f7db"]},
      :ductile/id #uuid"894281d9-2ee0-493e-ae78-50046e89d0e4",
      :db/id [:ductile/id #uuid"894281d9-2ee0-493e-ae78-50046e89d0e4"],
      :fahrzeug/vehicle {:db/id 17592186047331},
      :exit/transport-order {:ductile/id #uuid"e08db1f5-043d-46d7-9dd3-bee3cf637036",
                             :origin/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                               :compound/name "Ravenna",
                                               :compound/company {:db/id [:ductile/id
                                                                          #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                               :external.bmw/location-codes #{"RAVPOD"}},
                             :destination/location {:ductile/id #uuid"189d9a8d-981a-4df3-a33d-c1342e691c17",
                                                    :location/name "Pyongtaek",
                                                    :external.bmw/location-codes #{"PTKPOA"}},
                             :transport/mode :mode/ship,
                             :external.bmw/carrier-code "0019789510",
                             :external.bmw/spediteur "0001801",
                             :edi/instruction-ids #{"177683" "149054" "177684" "149053"}},
      :fahrzeug/workflow {:db/id [:ductile/id #uuid"fa2df335-a226-4194-8c7d-f66c06bac223"]}}
     {:ductile/id #uuid"8dc009c2-4ac5-4f42-9181-ab2f0fa4ee9d",
      :ductile/location {:db/id [:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40"]},
      :fahrzeug/customer {:db/id [:ductile/id #uuid"60f055be-177e-4603-b9a7-3b0f7bb2f7db"]},
      :fahrzeug/workflow {:db/id [:ductile/id #uuid"fa2df335-a226-4194-8c7d-f66c06bac223"]},
      :fahrzeug/vehicle {:db/id 17592186047923},
      :fahrzeug/storage-care-start-datetime #inst"2023-03-22T00:00:00.000-00:00",
      :entry/transport-order {:ductile/id #uuid"e15c8144-bf89-4999-81e5-39a437aa0a9c",
                              :origin/location {:external.bmw/location-codes #{"GRZPL"}},
                              :destination/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                                     :compound/name "Ravenna",
                                                     :compound/company {:db/id [:ductile/id
                                                                                #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                                     :external.bmw/location-codes #{"RAVPOD"}},
                              :transport/mode :mode/train,
                              :transport/load-number "740336823802911552-0",
                              :external.bmw/carrier-code "0068207710",
                              :external.bmw/spediteur "0000021",
                              :edi/instruction-ids #{"186957" "186958"}},
      :db/id [:ductile/id #uuid"8dc009c2-4ac5-4f42-9181-ab2f0fa4ee9d"]}
     {:ductile/location {:db/id [:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40"]},
      :entry/expected-datetime #inst"2023-03-31T00:00:00.000-00:00",
      :fahrzeug/storage-care-start-datetime #inst"2023-03-27T00:00:00.000-00:00",
      :entry/transport-order {:ductile/id #uuid"709b3b36-2195-43d3-9e92-c580977ecfd4",
                              :origin/location {:ductile/id #uuid"c265c10c-2143-4155-9c29-55708e7cffe2",
                                                :location/name "Dingolfing",
                                                :external.bmw/location-codes #{"DGFPL"}},
                              :destination/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                                     :compound/name "Ravenna",
                                                     :compound/company {:db/id [:ductile/id
                                                                                #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                                     :external.bmw/location-codes #{"RAVPOD"}},
                              :external.bmw/carrier-code "0068207710",
                              :edi/instruction-ids #{"182511"}},
      :fahrzeug/customer {:db/id [:ductile/id #uuid"60f055be-177e-4603-b9a7-3b0f7bb2f7db"]},
      :ductile/id #uuid"35588a83-00d3-46ef-b982-38935d12457b",
      :db/id [:ductile/id #uuid"35588a83-00d3-46ef-b982-38935d12457b"],
      :fahrzeug/vehicle {:db/id 17592186050345},
      :exit/transport-order {:ductile/id #uuid"dccb423d-141d-4931-80cc-14a27a1b5938",
                             :origin/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                               :compound/name "Ravenna",
                                               :compound/company {:db/id [:ductile/id
                                                                          #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                               :external.bmw/location-codes #{"RAVPOD"}},
                             :destination/location {:ductile/id #uuid"189d9a8d-981a-4df3-a33d-c1342e691c17",
                                                    :location/name "Pyongtaek",
                                                    :external.bmw/location-codes #{"PTKPOA"}},
                             :transport/mode :mode/ship,
                             :external.bmw/carrier-code "0019789510",
                             :external.bmw/spediteur "0001801",
                             :edi/instruction-ids #{"182060" "182061" "182062" "182059"}},
      :fahrzeug/workflow {:db/id [:ductile/id #uuid"fa2df335-a226-4194-8c7d-f66c06bac223"]}}
     {:ductile/location {:db/id [:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40"]},
      :fahrzeug/storage-care-start-datetime #inst"2023-03-24T00:00:00.000-00:00",
      :entry/transport-order {:ductile/id #uuid"0bc21721-b801-41c6-a325-f47da1f95e50",
                              :origin/location {:ductile/id #uuid"c265c10c-2143-4155-9c29-55708e7cffe2",
                                                :location/name "Dingolfing",
                                                :external.bmw/location-codes #{"DGFPL"}},
                              :destination/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                                     :compound/name "Ravenna",
                                                     :compound/company {:db/id [:ductile/id
                                                                                #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                                     :external.bmw/location-codes #{"RAVPOD"}},
                              :transport/mode :mode/train,
                              :transport/load-number "734181723802911578-5",
                              :external.bmw/carrier-code "0068207710",
                              :external.bmw/spediteur "0000021",
                              :edi/instruction-ids #{"148324" "148325"}},
      :fahrzeug/customer {:db/id [:ductile/id #uuid"60f055be-177e-4603-b9a7-3b0f7bb2f7db"]},
      :ductile/id #uuid"dac6d0ed-2824-494a-8868-8df424e9862f",
      :db/id [:ductile/id #uuid"dac6d0ed-2824-494a-8868-8df424e9862f"],
      :fahrzeug/vehicle {:db/id 17592186046993},
      :exit/transport-order {:ductile/id #uuid"f173f160-6161-4a02-99c9-d79e241f3dbf",
                             :origin/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                               :compound/name "Ravenna",
                                               :compound/company {:db/id [:ductile/id
                                                                          #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                               :external.bmw/location-codes #{"RAVPOD"}},
                             :destination/location {:ductile/id #uuid"189d9a8d-981a-4df3-a33d-c1342e691c17",
                                                    :location/name "Pyongtaek",
                                                    :external.bmw/location-codes #{"PTKPOA"}},
                             :transport/mode :mode/ship,
                             :external.bmw/carrier-code "0019789510",
                             :external.bmw/spediteur "0001801",
                             :edi/instruction-ids #{"177709" "177710" "172462" "172463" "149076" "149075"}},
      :fahrzeug/workflow {:db/id [:ductile/id #uuid"fa2df335-a226-4194-8c7d-f66c06bac223"]}}
     {:ductile/location {:db/id [:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40"]},
      :entry/expected-datetime #inst"2023-03-29T00:00:00.000-00:00",
      :fahrzeug/storage-care-start-datetime #inst"2023-03-27T00:00:00.000-00:00",
      :entry/transport-order {:ductile/id #uuid"4e2432ea-47ce-493b-970b-d4e2fa62166b",
                              :origin/location {:ductile/id #uuid"c265c10c-2143-4155-9c29-55708e7cffe2",
                                                :location/name "Dingolfing",
                                                :external.bmw/location-codes #{"DGFPL"}},
                              :destination/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                                     :compound/name "Ravenna",
                                                     :compound/company {:db/id [:ductile/id
                                                                                #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                                     :external.bmw/location-codes #{"RAVPOD"}},
                              :external.bmw/carrier-code "0068207710",
                              :edi/instruction-ids #{"152435"}},
      :fahrzeug/customer {:db/id [:ductile/id #uuid"60f055be-177e-4603-b9a7-3b0f7bb2f7db"]},
      :ductile/id #uuid"87ca26ff-a1d1-41ef-baed-23a2424ff04b",
      :db/id [:ductile/id #uuid"87ca26ff-a1d1-41ef-baed-23a2424ff04b"],
      :fahrzeug/vehicle {:db/id 17592186048755},
      :exit/transport-order {:ductile/id #uuid"e7ca4164-ff33-4821-bf26-c17238050db9",
                             :origin/location {:ductile/id #uuid"aaaf91a6-e8be-4beb-b43a-543c23a7af40",
                                               :compound/name "Ravenna",
                                               :compound/company {:db/id [:ductile/id
                                                                          #uuid"71f92b1f-11a2-4244-9088-5865b399cbcb"]},
                                               :external.bmw/location-codes #{"RAVPOD"}},
                             :destination/location {:ductile/id #uuid"189d9a8d-981a-4df3-a33d-c1342e691c17",
                                                    :location/name "Pyongtaek",
                                                    :external.bmw/location-codes #{"PTKPOA"}},
                             :transport/mode :mode/ship,
                             :external.bmw/carrier-code "0019789510",
                             :external.bmw/spediteur "0001801",
                             :edi/instruction-ids #{"177838" "152059" "177837" "152058"}},
      :fahrzeug/workflow {:db/id [:ductile/id #uuid"fa2df335-a226-4194-8c7d-f66c06bac223"]}}]}])

(defn vehicle-status [fahrzeug]
  (cond (:exit/datetime fahrzeug) :exited
        (:exit/expected-datetime fahrzeug) :called-off
        (:fahrzeug/parking-spot fahrzeug) :in-storage
        (:entry/datetime fahrzeug) :at-entry
        (:entry/expected-datetime fahrzeug) :expected
        :else :unknown))

(def status+color
  {:in-storage "indigo"
   :at-entry "green"
   :called-off "orange"
   :exited "red"
   :expected "yellow"
   :unknown "gray"})

(def status+label
  {:expected (tr "Expected")
   :at-entry (tr "At entry")
   :exited (tr "Exited")
   :called-off (tr "Called off")
   :in-storage (tr "In storage")
   :unknown (tr "Unknown")})


(defn vehicle-chart [{:keys [fahrzeuge]}]
  (let [total (count fahrzeuge)
        grouped-by-status (group-by vehicle-status fahrzeuge)
        bar (fn [status]
              (when (get grouped-by-status status)
                [:div
                 {:class (str "bg-" (get status+color status) "-500")
                  :style {:width (str (* (/ (count (get grouped-by-status status)) total) 100) "%")}}]))]
    [:div [:div.overflow-hidden.w-full.flex.h-8.rounded.shadow
           {:style {:outline "1px solid rgba(0,0,0,.1)"
                    :outline-offset "-1px"}}
           (into
            [:div.flex-auto.flex]
            (map bar (keys status+label)))]]))

(defn vehicle-table [{:keys [fahrzeuge]}]
  (let [grouped-by-status (group-by vehicle-status fahrzeuge)
        table-row (fn [status]
                    (when (get grouped-by-status status)
                      [:tr.hover:bg-gray-50.cursor-pointer
                       [:td.pl-5
                        [:div.rounded-full.w-4.h-4.border {:class (str "bg-" (get status+color status) "-500")}]]
                       [:td.pl-5.py-2.whitespace-nowrap.text-xs (get status+label status)]
                       [:td.pl-5.py-2.whitespace-nowrap.text-xs (count (get grouped-by-status status))]]))]
    [:div.overflow-hidden.border-t
     [:table.min-w-full.divide-y.divide-gray-200
      [:thead.bg-gray-50
       [:tr
        [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
         {:scope "col"}
         [:div.rounded-full.w-4.h-4.border.border-gray-300]]
        [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
         {:scope "col"}
         (tr "Status")]
        [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
         {:scope "col"}
         (tr "Number of vehicles")]]]
      (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
            (map table-row (keys status+label)))
      [:tfoot.bg-white.divide-y.divide-gray-200.text-sm
       [:tr.bg-gray-50
        [:td]
        [:td.pl-5.py-2.whitespace-nowrap.font-bold.text-xs
         (tr "Total")]
        [:td.text-left.py-2.px-5.whitespace-nowrap.font-bold.text-xs
         (count fahrzeuge)]]]]]))

(defn compound-dashboard-view [{:keys [events-by-hour events vehicle-motion-viz vehicle-motion]} _match]
  (let [!motion-details-visible? (deframe/!route-get ::motion-details-visible? false)]
    [:div.grid.grid-cols-2.gap-5
     [:div.flex.flex-col.gap-5
      [ui/panel {:variant :full}
       [ui/panel-content
        [:h2.text-lg (tr "Vehicles overview")]
        [:div.text-xs.mb-4
         [ui/link
          {:variant :primary
           :on-click #(deframe/route-update! ::motion-details-visible? not)}
          (if @!motion-details-visible?
            [ui/icon :eye-open]
            [ui/icon :eye-none])
          (if @!motion-details-visible?
            (tr "Hide details")
            (tr "Show details"))]]
        [render/inspect-presented vehicle-motion-viz]
        (when @!motion-details-visible?
          [:div.mt-3
           [render/inspect (viewer/table vehicle-motion)]])]]]
     [:div
      [:div
       [ui/panel {:variant :full}
        [ui/panel-content
         [ui/tabs {:default-value :grouped}
          [:div
           [:h2.text-lg (tr "Recent events")]
           [:div.mb-4
            [ui/text-tabs-list
             [ui/text-tab {:value :grouped} (tr "Grouped")]
             [:div.border-r.mx-2]
             [ui/text-tab {:value :raw} (tr "Raw")]]]]
          [ui/tab-content {:value :grouped :class ""}
           [ui/grouped-events-list events-by-hour]]
          [ui/tab-content {:value :raw :class ""}
           [:div.not-prose
            (into
             [:ul.flex.flex-col.gap-3.text-sm]
             (map (fn [event]
                    [ui/event-item event]))
             events)]]]]]]]]))

(defn compound-statistics-view [{:keys [by-month-and-customer customers header by-month by-year]} _match]
  (let [current-year (.getFullYear (js/Date.))
        all (or (some-> (get-in @deframe/!current-route [:query-params :all]) (js/parseInt)) 0)
        year (or (some-> (get-in @deframe/!current-route [:query-params :year]) (js/parseInt)) current-year)
        months (map #(str year "-" (.padStart (str %) 2 "0")) (range 1 13))
        rows (for [customer (concat (vec customers) ["Gesamt (nur Lager)" "Gesamt"])]
               (apply merge
                      {:contract/name customer}
                      (for [month (seq months)]
                        {month (get by-month-and-customer [month customer])})))
        transform (->> months
                       (map (fn [k] [[k] (fn [row] {:number (get row k) :digits 2})]))
                       (into {}))
        footers ["Gesamt (nur Lager)" "Gesamt"]]
    [ui/panel {:variant :full}
     [ui/panel-content
      [:div.flex.flex-col.gap-5
       [:div.flex.gap-3.items-center
        [:h1.text-lg.font-bold (tr "Monthly statistics")]
        [:div.w-24
         [combobox/view {:size 4
                         :choices (->> (range 2023 (inc current-year))
                                       (map combobox/->choice)
                                       reverse)
                         :value (combobox/->choice year)
                         :on-change (fn [{year :ui/value}]
                                      (router/navigate-to (router/path '[compound :compound-name statistics]
                                                                       (:path-params @deframe/!current-route)
                                                                       (str "year=" year "&all=" all))))}]]
        [combobox/view {:size 4
                        :choices [{:ui/value 0 :ui/label "Aggregated"}
                                  {:ui/value 1 :ui/label "All sub-contracts"}]
                        :value (get [{:ui/value 0 :ui/label "Aggregated"}
                                     {:ui/value 1 :ui/label "All sub-contracts"}] all)
                        :on-change (fn [{all :ui/value}]
                                     (router/navigate-to (router/path '[compound :compound-name statistics]
                                                                      (:path-params @deframe/!current-route)
                                                                      (str "year=" year "&all=" all))))}]]
       [:div.flex.flex-col.gap-5
        [:div
         [table/table {#_#_:head (concat [:contract/name] months)
                       :column-order (concat [:contract/name] months [:average])
                       :column-widths {:contract/name 400}
                       #_#_:class "table-fixed"
                       :transform-columns transform
                       :footer (map
                                (fn [{:as total customer :contract/name}]
                                  (concat [customer]
                                          (map (fn [m] {:number (get total m) :digits 2}) months)))
                                (filter (comp (set footers) :contract/name) rows))}
          (remove (comp (set footers) :contract/name) rows)
          rows]]

        (into [:<>]
              (map (fn [year]
                     [:div.max-w-96
                      [table/table {:column-order [:contract/name :count]
                                    :transform-columns transform
                                    :footer (map (fn [footer]
                                                   [(tr footer) {:number (get year footer)
                                                                 :digits 2}])
                                                 footers)}
                       (->> (apply dissoc year :year footers)
                            (sort-by first)
                            (into []
                                  (map (fn [[contract number]]
                                         {:contract/name contract :count {:number number :digits 2}}))))]]))
              by-year)]]]]))

(defn fahrzeug->link [fahrzeug]
  (viewer/html [ui/link {:href (str "/compound/" (:compound/name fahrzeug) "/vehicle/" (:ductile/id fahrzeug))}
                [ui/vin (:vehicle/vin fahrzeug)]]))

(defn export-button [params]
  (let [export-running? (r/atom false)]
    (fn []
      [ui/button
       {:disabled? @export-running?
        :variant :primary
        :size 2
        :on-click (fn [_]
                    (reset! export-running? true)
                    (-> (ductile.ui.http/download
                         "/api/lambda"
                         (merge {:lambda/handlers `[ductile.insights.reports/report
                                                    ductile.spreadsheet/export-xlsx]}
                                params))
                        (.then #(reset! export-running? false))))}
       icons/excel
       (tr "Export")])))

(defn compound-report-show [report match]
  [:div
   [ui/page-title (tr (:title report))
    [export-button (merge {:compound/name @deframe/!current-compound
                           :report/id (:report/id report)}
                          (:query-params @deframe/!current-route))]]
   [:div.flex.gap-6
    (when-let [schema (:malli/params-schema report)]
      (let [current-route @deframe/!current-route
            ;;remove path params from schema to get a schema that only includes params set through query params
            query-params-schema (reduce (fn [schema path-param]
                                          (malli.util/dissoc schema path-param))
                                        schema
                                        (keys (:path-params match)))
            report-params @(deframe/!route-get
                            ::report-params
                            (some-> current-route
                                    :query-params
                                    :b64
                                    base64/decode
                                    edn/read-string))]
        (when (not-empty (m/children query-params-schema))
          [:div.bg-slate-50.self-start.border.rounded-lg.shadow-sm.flex.flex-col.gap-2.p-2 {:style {:width 300}}
           [schema-based-editor/editor
            {:schema query-params-schema
             :editing? true
             :value report-params
             :on-change (fn [v] (deframe/route-assoc! ::report-params v))}]
           [:div.flex.items-center
            [ui/button {:variant :primary
                        :size 3
                        :on-click #(router/navigate-to (router/path current-route {:b64 (base64/encode (pr-str report-params))}))}
             (tr "Apply")]]])))
    (let [data (:data report)
          multi-table? (and (sequential? data)
                            (seq data)
                            (every? #(and (:title %) (:rows %)) data))
          render-opts (cond-> {:nextjournal.clerk/viewers
                               (viewer/add-viewers [(ui.vehicle-search/inst->compound-time-str-viewer {:compound/name @deframe/!current-compound})
                                                    dcv/uuid->str-viewer
                                                    dcv/translated-keywords-viewer])
                               :nextjournal.clerk/page-size nil
                               :nextjournal.clerk/budget nil}
                        (:nextjournal.clerk/render-opts report)
                        (assoc :nextjournal.clerk/render-opts (:nextjournal.clerk/render-opts report)))
          add-vin-links (fn [rows]
                          (map #(cond-> %
                                  (:vehicle/vin %)
                                  (assoc :vehicle/vin (fahrzeug->link %)))
                               rows))]
      (if multi-table?
        (into [:div]
              (for [{:keys [title rows]} data]
                [:div.mb-6
                 [:h3.text-lg.font-semibold.mb-2 title]
                 [render/inspect (viewer/table render-opts (add-vin-links rows))]]))
        [render/inspect (viewer/table render-opts (add-vin-links data))]))]])

(defn compound-report-dashboard [{:keys [reports]} _match]
  [:div
   [ui/page-title (tr "Reports Dashboard")]
   [:div.flex.gap-6
    [table/table {:schema [:report :description]
                  :translated-keys {:report (tr "Report")
                                    :description (tr "Description")}
                  :transform-columns
                  {[:report]
                   (fn [report]
                     [ui/link
                      {:href (router/path (or (:template report)
                                              '[insights :compound/name reports :report/id])
                                          {:compound/name @deframe/!current-compound
                                           :report/id (name (:report-id report))}
                                          (:query-string report))}
                      (:ductile.lambda/report report)])}}
     (map (fn [[report-id report]]
            (assoc report :report-id report-id)) reports)]]])

(defn render-transport-orders [_result {:keys [path-params] :as _match}]
  [ui/loading-promise-view transport-orders-overview (-> (http/active-transport-orders (:compound-name path-params))
                                                         (.then #(ok->> % (hash-map :fahrzeuge))))])


(defn simulate-frontend-errors
  "Component for the sole purpose of simulating errors in the fronted code"
  [_result _match]
  [:div
   [ui/button {:on-click (fn [] (throw (ex-info "SIMULATED CLICK HANDLER ERROR" {})))}
    "Simulate click handler error"]

   [ui/button {:on-click (fn [] (deframe/assoc! ::simulate-error? true))}
    "Simulate component render error"]
   (when @(deframe/!get ::simulate-error?)
     (throw (ex-info "SIMULATED COMPONENT RENDER ERROR" {})))])

(defn lead-times-view [{:as params :keys [compound-name by-month by-week by-day by-week-chart last-three-weeks]} _match]
  (let [filter-data (select-keys params [:after :before])
        round (fn [data]
                (map #(into {} (map (fn [[k v]] (if (str/starts-with? (name k) "<=") [k {:number v :digits 2}] [k v])) %)) data))]
    [ui/panel {:variant :full}
     [ui/panel-content
      [:div.flex.items-center.justify-between.pb-3.border-b-2.mb-3
       [:h1.text-2xl.font-bold (tr "Lead times")]]

      [:div.flex.items-center.justify-between.pb-6
       [:div.flex.items-center
        [ui/date-range-picker
         (assoc filter-data
                :on-change (fn [range] (ductile.ui.deframe/route-refetch! range)))]]

       [:div.flex.items-center.gap-2
        [ui/button
         {:variant :primary
          :size 1
          :on-click (fn [filters]
                      (http/download
                       "/api/lambda"
                       (merge {:lambda/handlers '[ductile.insights.bmw-lead-times/lead-times-raw
                                                  ductile.spreadsheet/export-xlsx]
                               :compound/name compound-name}
                              filter-data)))}
         (tr "Download Excel")]]]

      [:div.flex.gap-5
       [:div
        [:h3.text-base.font-bold.mb-2 (tr "Percentages plot by week")]
        [render/inspect-presented by-week-chart]]
       [:div
        [:h3.text-base.font-bold.mb-2 (tr "Lead times plot per day")]
        [render/inspect-presented last-three-weeks]]]

      [:div.flex.flex-col.gap-5
       [:div
        [:h2.text-lg.font-bold.mb-3 (tr "By month")]
        [table/table {}
         (round by-month)]]

       [:div
        [:h2.text-lg.font-bold.mb-3 (tr "By week")]
        [table/table {}
         (round by-week)]]

       [:div
        [:h2.text-lg.font-bold.mb-3 (tr "By day")]
        [table/table {}
         (round by-day)]]]]]))


(defn elog-lead-times-view [{:as params :keys [compound-names by-month by-week by-day by-week-chart last-three-weeks]} _match]
  (let [filter-data {:after (or (:after params) (ui/add-days (ui/now) -31))
                     :before (or (:before params) (ui/add-days (ui/now) -1))}
        !compound-names (hooks/use-state (or (some-> compound-names set) #{}))
        !date-range (hooks/use-state filter-data)]
    [ui/panel {:variant :full}
     [ui/panel-content
      [:div.flex.items-center.justify-between.pb-3.border-b-2.mb-3
       [:h1.text-2xl.font-bold (tr "ELOG Lead times")]]

      [:div.flex.items-start.justify-between.pb-6
       (into [:div]
             (map (fn [compound-name]
                    [:label.block.flex.gap-2.items-center {:class "p-0.5"}
                     [:input {:type :checkbox
                              :checked (contains? @!compound-names compound-name)
                              :on-change #(swap! !compound-names
                                                 (if (contains? @!compound-names compound-name) disj conj)
                                                 compound-name)}]
                     compound-name]))
             ["Eitting"
              "Hodenhagen"
              "Klitschmar"
              "Knautnaundorf"
              "Krefeld"
              "Nürnberg"
              "Regensburg"
              "Riedstadt"
              "Wolnzach"])
       [:div.flex.items-center
        [ui/date-range-picker
         (assoc @!date-range
                :live? true
                :on-change #(reset! !date-range %))]]

       [:div.flex.items-center.gap-2
        [ui/button
         {:variant :primary
          :size 1
          :disabled? (not (and (:before @!date-range) (:after @!date-range)
                               (seq @!compound-names)))
          :on-click (fn [_]
                      (http/download
                       "/api/lambda"
                       (merge {:lambda/handlers '[ductile.insights.elog-lead-times/elog-lead-times-raw
                                                  ductile.spreadsheet/export-xlsx]
                               :compound/names @!compound-names}
                              @!date-range)))}
         (tr "Download Excel")]]]]]))


(defc parking-spots [{:keys [spots->fz zone->dimensions]} match]
  (let [compound-name (get-in match [:path-params :compound-name])]
    (into [:div.text-xs.tabular-nums [:h1.text-xl "Parking " compound-name]]
          (map (fn viz-zone [[zone row-info]]
                 (let [max-spots (reduce max (map (partial reduce max) (vals (:spots row-info))))]
                   [:div
                    [:h2.text-lg.pt-5.pl-3 zone]
                    [:div.bg-white.rounded.shadow.overflow-scroll
                     (into [:div.grid.w-fit
                            {:style {:grid-template-columns (str "repeat(" (inc max-spots) ",1fr)")}}
                            [:<> (map (fn [spot] (if (zero? spot)
                                                   [:div.bg-slate-100.sticky.left-0.z-10 {:class "w-[30px] h-[30px] text-[11px]"}]
                                                   [:div.bg-slate-100.flex.justify-center.items-center.border-b.border-slate-300 {:class "w-[30px] h-[30px] text-[11px]"} [:span spot]])) (range (inc max-spots)))]]
                           (mapcat
                            (fn viz-row [[row spots]]
                              (into [[:div.bg-slate-100.flex.justify-center.items-center.border-r.border-slate-300.sticky.left-0.z-10 {:class "w-[30px] h-[30px] text-[11px]"} [:span row]]]
                                    (map (fn viz-spot [spot]
                                           (if (contains? (set spots) spot)
                                             (let [fz (get-in spots->fz [zone row spot])
                                                   c (count fz)]
                                               [:div.p-1.aspect-square.flex.justify-center.items-center
                                                {:style {:width "30px"
                                                         :height "30px"}
                                                 :class (str (case c
                                                               0 "bg-blue-100"
                                                               1 "bg-blue-300"
                                                               2 "bg-red-500"))
                                                 :title (str row "/" spot ": " (:vehicle/vin (first fz)))}
                                                (if-let [f (first fz)]
                                                  [:a {:href (router/path '[compound :compound/name vehicle :ductile/id] f)} c]
                                                  [:span c])])
                                             [:div.bg-slate-50 {:style {:width "30px" :height "30px"}}])))
                                    (range 1 (inc max-spots)))))
                           (sort (:spots row-info)))]])))
          zone->dimensions)))
